<template>
  <div>
    <Head title="Crear Devolución" />
    <h1 class="mb-8 text-3xl font-bold">Crear Devolución</h1>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="submit">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="w-full pb-8 pr-6">
            <label class="form-label">Orden</label>
            <select v-model="form.order_id" class="form-select" required>
              <option value="">Seleccione una orden</option>
              <option v-for="order in orders" :key="order.id" :value="order.id">
                #{{ order.number_order }} - {{ order.client.name }}
              </option>
            </select>
          </div>

          <div class="w-full pb-8 pr-6">
            <label class="form-label">Tipo de Devolución</label>
            <select v-model="form.return_type" class="form-select" required>
              <option value="partial">Parcial</option>
              <option value="complete">Completa</option>
            </select>
          </div>

          <template v-if="selectedOrder">
            <div class="w-full pb-8 pr-6">
              <h3 class="text-lg font-medium mb-4">Productos de la Orden</h3>
              <div class="space-y-4">
                <div v-for="product in selectedOrder.products" :key="product.id" class="flex items-center space-x-4">
                  <div class="flex-1">
                    <label class="form-label">{{ product.product.name }}</label>
                    <div class="text-sm text-gray-600">
                      Cantidad original: {{ product.quantity }}
                    </div>
                  </div>
                  <div class="w-32">
                    <label for="return_quantity">Cantidad</label>
                    <input
                      type="number"
                      v-model="form.products[product.id].return_quantity"
                      class="form-input"
                      :min="0"
                      :max="product.quantity"
                      required
                    />
                  </div>
                  <div class="w-32">
                    <label for="return_amount">Monto</label>
                    <input
                      type="number"
                      v-model="form.products[product.id].return_amount"
                      class="form-input"
                      :min="0"
                      :max="product.price * product.quantity"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full pb-8 pr-6">
              <label class="form-label">Método de Reembolso</label>
              <select v-model="form.refund_method" class="form-select">
                <option value="">Sin reembolso</option>
                <option value="cash">Efectivo</option>
                <option value="transfer">Transferencia</option>
                <option value="credit_note">Nota de Crédito</option>
              </select>
            </div>

            <div v-if="form.refund_method" class="w-full pb-8 pr-6">
              <label class="form-label">Referencia del Reembolso</label>
              <input
                type="text"
                v-model="form.refund_reference"
                class="form-input"
                :required="!!form.refund_method"
              />
            </div>

            <div class="w-full pb-8 pr-6">
              <label class="form-label">Notas</label>
              <textarea
                v-model="form.notes"
                class="form-textarea"
                rows="3"
              ></textarea>
            </div>
          </template>
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link class="btn-gray" href="/devolutions">Cancelar</Link>
          <button
            class="btn-blue ml-3"
            :disabled="form.processing"
          >
            Crear Devolución
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    orders: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const form = useForm({
      order_id: '',
      return_type: 'partial',
      products: {},
      refund_method: '',
      refund_reference: '',
      notes: '',
    })

    return { form }
  },
  computed: {
    selectedOrder() {
      return this.orders.find(order => order.id === this.form.order_id)
    }
  },
  watch: {
    'form.order_id': {
      handler(newOrderId) {
        if (newOrderId) {
          const order = this.orders.find(o => o.id === newOrderId)
          if (order) {
            this.form.products = order.products.reduce((acc, product) => {
              acc[product.id] = {
                return_quantity: 0,
                return_amount: 0,
                reason: ''
              }
              return acc
            }, {})
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    submit() {
      this.form.post('/devolutions')
    }
  }
}
</script>
